module.exports = __webpack_public_path__ + "img/credit-card.65e0e923.svg";